import { roles } from '@nxsys/store/constants';
import ExportListing from '../../../modules/export/listing';

export const exportConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/export',
    element: <ExportListing />,
  },
];
